// Recipients for admin email notifications (contact form, chatbot leads).
// Edit here to change where Tom receives notifications from the website.
export const ADMIN_NOTIFICATION_EMAILS = [
  'info@tomartmask.cz',
  'vesely.info@gmail.com',
] as const;
